import type { FieldTypeConfiguration } from "../type";

export const phoneFieldConfiguration: FieldTypeConfiguration = {
  field: "phone",
  sections: [
    {
      title: "Detalles",
      fields: [
        {
          key: "fieldName",
          type: "text",
          label: "Nombre del campo",
          placeholder: "Nombre del campo",
          required: true,
        },
      ],
    },
    {
      title: "Opciones",
      showSeparator: true,
      fields: [
        {
          key: "hasDropdownButton",
          type: "switch",
          label: "¿Agregar botón dropdown al campo?",
          required: true,
          defaultValue: false,
        },
        {
          key: "buttonPosition",
          type: "select",
          label: "Posición del botón",
          required: true,
          options: [
            { value: "left", label: "Izquierda" },
            { value: "right", label: "Derecha" },
          ],
          defaultValue: "left",
          condition: (formValues) => formValues.hasDropdownButton === true,
        },
        {
          key: "valueSource",
          type: "radio",
          label: "¿De dónde provienen los valores?",
          required: true,
          options: [
            { value: "database", label: "Desde centro de datos" },
            { value: "manual", label: "Locales" },
          ],
          defaultValue: "database",
          condition: (formValues) => formValues.hasDropdownButton === true,
        },
        {
          key: "valueDatacenter",
          type: "datacenter",
          required: true,
          label: "Centro de datos",
          condition: (formValues) =>
            formValues.hasDropdownButton === true &&
            formValues.valueSource === "database",
        },
        {
          key: "localList",
          type: "local_list",
          label: "Lista local",
          required: true,
          helperText:
            "El primer valor de la lista será el pre-seleccionado por default",
          condition: (formValues) =>
            formValues.hasDropdownButton === true &&
            formValues.valueSource === "manual",
        },
        {
          key: "multipleSelection",
          type: "switch",
          label: "Listado de selección múltiple",
          required: false,
          defaultValue: false,
          condition: (formValues) =>
            formValues.hasDropdownButton === true &&
            formValues.valueSource === "manual",
        },
        {
          key: "expandSelectedRecord",
          type: "switch",
          label: "Expandir registro seleccionado",
          required: true,
          defaultValue: false,
          customProps: {
            switchFalseText: "No, generar una sola variable (array)",
          },
          condition: (formValues) =>
            formValues.hasDropdownButton === true &&
            formValues.valueSource === "database",
        },
      ],
    },
    {
      title: "Configuración",
      showSeparator: true,
      fields: [
        {
          key: "placeholder",
          type: "text",
          label: "Placeholder del campo",
          placeholder: "Placeholder del campo",
          required: true,
        },
        {
          key: "defaultValue",
          type: "default_value",
          label: "Valor por defecto",
          placeholder: "Escribe un valor por defecto",
          helperText: "Si está vacío no se aplicará ningún valor por defecto.",
          defaultValue: "",
          customProps: {
            prefixText: "inp",
            helperTextIcon: "circle-info",
            helperTextColor: "text-info",
          },
        },
      ],
    },
  ],
};
